(() => {
  // ✅ slider 안에서 "현재 보이는(활성)" 비디오를 우선 찾기
const getActiveVideo = (slider) => {
  if (!slider) return null;
  return (
    slider.querySelector(".swiper-slide-active video") ||
    slider.querySelector(".slideshow__slide.is-active video") ||
    slider.querySelector(".slideshow__video video") ||
    slider.querySelector("video")
  );
};

const playVideo = (slider) => {
  if (!slider) return;

  // ✅ 연속 호출(슬라이드체인지 + IO)로 play/pause 충돌 방지: 디바운스
  if (slider.__sbPlayTimer) clearTimeout(slider.__sbPlayTimer);

  slider.__sbPlayTimer = setTimeout(() => {
    const video = getActiveVideo(slider);
    if (!video) return;

    // ✅ autoplay 정책 대응(무음 + playsinline)
    video.muted = true;
    video.setAttribute("muted", "");
    video.playsInline = true;
    video.setAttribute("playsinline", "");

    // ✅ 이미 재생 중이면 다시 play() 시도하지 않음
    if (!video.paused && !video.ended) return;

    const p = video.play();
    // ✅ AbortError 같은 노이즈는 무시(콘솔 깔끔)
    if (p && typeof p.catch === "function") p.catch(() => {});
  }, 80);
};

const stopVideo = (slider) => {
  if (!slider) return;

  // ✅ 예약된 play()가 있으면 먼저 취소
  if (slider.__sbPlayTimer) {
    clearTimeout(slider.__sbPlayTimer);
    slider.__sbPlayTimer = null;
  }

  // ✅ slider 안의 비디오를 전부 pause
  slider.querySelectorAll("video").forEach((v) => {
    try {
      if (!v.paused) v.pause();
    } catch (e) {}
  });
};

  const initSlider = (section) => {
    if (!section || !section?.classList.contains("section-slideshow")) return;

    const box = section.querySelector(".slideshow");

    if (box) {
      const swiperParams = {
        speed: 700,
        autoHeight: false,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
      };

      const changeColorScheme = (swiper) => {
  // ✅ swiper 자체가 없으면 종료
  if (!swiper) return;

  // ✅ activeIndex / slides가 없을 때도 종료
  const activeIndex = typeof swiper.activeIndex === "number" ? swiper.activeIndex : 0;
  const slide = swiper.slides?.[activeIndex];
  if (!slide) return;

  // ✅ slide가 HTMLElement일 수도 있고 {el: HTMLElement}일 수도 있어 둘 다 대응
  const el = slide.el ? slide.el : slide;

  // ✅ dataset이 없으면 기존처럼 터지므로 안전하게 읽기
  const colorScheme =
    el?.dataset?.colorScheme ||
    el?.getAttribute?.("data-color-scheme");

  if (!colorScheme) return;

  const changeItems = [
    swiper.navigation?.nextEl,
    swiper.navigation?.prevEl,
    swiper.pagination?.el,
  ];

  changeItems.forEach((item) => {
    if (!item) return;

    let classNames = item.getAttribute("class") || "";
    classNames = classNames.replace(/color-background-\d+/g, "");
    item.setAttribute("class", classNames);
    item.classList.add(colorScheme);
  });
};
      

      if (box.getAttribute("data-autoplay") === "true") {
        swiperParams.autoplay = {
          delay: Number(section.querySelector('.slideshow').dataset.duration),
          disableOnInteraction: false,
          pauseOnMouseEnter: box.getAttribute("data-pause-autoplay-hover") === "true",
        };
        swiperParams.on = {
          autoplayTimeLeft(s, time, progress) {
            if (isNaN(progress)) {
              return;
            }

            const invertedProgress = 1 - progress;
            const activeBullet = section.querySelector(
              ".swiper-pagination-bullet-active"
            );

            if (activeBullet) {
              activeBullet.style.setProperty(
                "--width-bg",
                `${invertedProgress * 100}%`
              );
            }
          }
        }
      }

      if (box.getAttribute("data-loop") === "true") {
        swiperParams.loop = true;
        //swiperParams.loopPreventsSliding = false;
      }

      if (box.getAttribute("data-pagination") === "true") {
        const paginationEl = box.querySelector(".swiper-pagination");

        swiperParams.pagination = {
          el: paginationEl,
          type: "bullets",
          clickable: true,
        };
      }

      if (box.getAttribute("data-navigation") === "true") {
        const prevBtn = box.querySelector(".slideshow__navigation-button-prev");
        const nextBtn = box.querySelector(".slideshow__navigation-button-next");

        swiperParams.navigation = {
          nextEl: nextBtn,
          prevEl: prevBtn,
        };
      }

      if (box.getAttribute("data-parallax") === "true") {
        swiperParams.parallax = true;
      }

      if (box.getAttribute("data-animation-type") === "fade") {
        swiperParams.effect = "fade";
      } else {
        swiperParams.effect = "slide";
      }

      swiperParams.breakpoints = {
        990: {
          spaceBetween: 8,
        },
      };
      

      const sliderOverlay = box.querySelector(".slideshow__swiper--overlay");

      if (sliderOverlay) {
        // ✅ loop 경고 방지: 슬라이드 개수에 따라 loop 자동 제어
const slidesCount = sliderOverlay.querySelectorAll(".swiper-slide").length;

const spv = typeof swiperParams.slidesPerView === "number" ? swiperParams.slidesPerView : 1;
const spg = typeof swiperParams.slidesPerGroup === "number" ? swiperParams.slidesPerGroup : 1;

// 슬라이드가 충분할 때만 loop ON
swiperParams.loop = slidesCount > Math.max(spv, spg);

// slidesPerGroup이 슬라이드보다 크면 줄여서 안정화
swiperParams.slidesPerGroup = Math.min(spg, Math.max(1, slidesCount));
const swiperOverlay = new Swiper(sliderOverlay, swiperParams);

        changeColorScheme(swiperOverlay);
        swiperOverlay.on("slideChange", function () {
          changeColorScheme(swiperOverlay);
          playVideo(sliderOverlay);

          if (box.getAttribute("data-autoplay") === "true") {
            const bullets = section.querySelectorAll('.swiper-pagination-bullet');
            bullets.forEach((bullet) => {
              bullet.style.setProperty('--width-bg', '0%'); 
            });
          }
        });

        if (box.getAttribute("data-pagination") === "true" || box.getAttribute("data-navigation") === "true") {
          if (sliderOverlay.querySelector('.slideshow__controls-wrapper')) {
            const widthControls = sliderOverlay.querySelector('.slideshow__controls-wrapper').offsetWidth + 'px';
            section.querySelector('.slideshow--with-controls').style.setProperty('--width-controls', `${widthControls}`);
          }
        }
      }
      
    }
  };

  const initSection = (section) => {
    if (!section || !section?.classList.contains("section-slideshow")) return;

    const slider = section.querySelector(".slideshow__swiper");

    if (!slider) return;

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (slider) {
            playVideo(slider);
          }
        } else {
          if (slider) {
            stopVideo(slider);
          }
        }
      });
    });

    sectionObserver.observe(section);

    initSlider(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
